import { CustomStatusSwitch } from "./CustomStatusSwitch";

export const customStatusUiField = {
  status: {
    "ui:field": CustomStatusSwitch,
  },
};
